module.exports = __webpack_public_path__ + "static/media/14_tn.97479fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/14_tn.jpg
// module id = 323
// module chunks = 0